/**
 * App component
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
import { AfterContentInit, Component } from '@angular/core';
import { WdLocalEnvironmentService } from './services/environment/wd-local-environment.service';
import { IEnvironmentModel } from './interfaces/environment/environment-interfaces';
import { WdLocalSharedFunctionsService } from './services/shared/wd-local-shared-functions.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterContentInit {
  // Environment / User
  environmentValues: IEnvironmentModel;
  userInformation: any;

  // Booleans
  isInitialized = false;

  // Company Name and Year
  internalCompanyName = 'BuildCentrix';
  currentYear = new Date().getFullYear();

  /**
   * Constructor
   */
  constructor(
    public wdLocalEnvironmentService: WdLocalEnvironmentService,
    public wdLocalSharedFunctionsService: WdLocalSharedFunctionsService,
  ) {}

  /**
   * After content init
   */
  ngAfterContentInit() {
    // Set initialized environment values
    this.environmentValues = this.wdLocalEnvironmentService.values;
    this.userInformation = this.wdLocalEnvironmentService.values.user;
    this.isInitialized = this.wdLocalEnvironmentService.isInitialized.value;
  }
}

// EOF
